import * as React from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import styled from 'styled-components'
import { useFegliCalculations } from '../../hooks/useFegliCalculations'
import { selectData } from 'layouts/onboarding'
import fegliLogo from 'assets/images/fegliLogo.png'

function createData(
  name,
  providerLogo,
  logoHeight,
  coverage,
  monthlyPremium,
  ageCoverage
) {
  return {
    name,
    providerLogo,
    logoHeight,
    coverage,
    monthlyPremium,
    ageCoverage,
  }
}
const dollarFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})

const StyledProviderLogo = styled.img`
  min-height: 20px;
  width: auto;
  display: block;
  margin: 0 auto;
`
export const LifeInsuranceSummary = ({
  tableTimeHorizon = 'monthly',
  tableStates,
}) => {
  const {
    plannedRetirementMonth,
    plannedRetirementDay,
    plannedRetirementYear,
    bedb,
    basicLife,
    optionA,
    optionB,
    optionC,
    fegliTotal,
    privateInsurance,
    allLifeInsuranceTotal,
  } = useFegliCalculations()

  const timeFactor = tableTimeHorizon === 'monthly' ? 1 : 12

  const rows = []

  const bedbRow =
    bedb &&
    rows.push(
      createData(
        'Basic Employee Death Benefit',
        'https://www.opm.gov/cdn/img/opm-uswds/opm_logo.svg',
        '36px',
        dollarFormat.format(bedb),
        '$0',
        '120'
      )
    )
  const basicLifeRow =
    basicLife &&
    rows.push(
      createData(
        'Basic Life',
        fegliLogo,
        '24px',
        dollarFormat.format(basicLife?.coverage),
        dollarFormat.format(basicLife?.premium * timeFactor),
        '120'
      )
    )
  const optionARow =
    optionA &&
    rows.push(
      createData(
        'Option A',
        fegliLogo,
        '24px',
        dollarFormat.format(optionA?.coverage),
        dollarFormat.format(optionA?.premium * timeFactor),
        '120'
      )
    )
  const optionBRow =
    optionB &&
    rows.push(
      createData(
        'Option B',
        fegliLogo,
        '24px',
        dollarFormat.format(optionB?.coverage),
        dollarFormat.format(optionB?.premium * timeFactor),
        '120'
      )
    )
  // const optionCRow =
  //   optionC &&
  //   rows.push(
  //     createData(
  //       'Option C',
  //       fegliLogo,
  //       '24px',
  //       dollarFormat.format(optionC.coverage),
  //       dollarFormat.format(optionC.premium),
  //       '120'
  //     )
  //   )
  // rows.push(
  //   createData(
  //     'FEGLI Total',
  //     '',
  //     '',
  //     dollarFormat.format(fegliTotal.coverage),
  //     dollarFormat.format(fegliTotal.premium * timeFactor),
  //     ''
  //   )
  // )
  const privateInsuranceRows = privateInsurance.map((policy) => {
    const providerInfo = selectData.privateLifeInsuranceProviders.find(
      (p) => p.value === policy.provider
    )
    const typeInfo = selectData.privateLifeInsuranceTypes.find(
      (t) => t.value === policy.type
    )

    const providerLabel = providerInfo?.label || 'Not Selected'
    const providerLogo = providerInfo?.logo || ''
    const typeLabel = typeInfo?.label || 'Not Selected'

    return createData(
      `${providerLabel} - ${typeLabel}`,
      providerLogo,
      '32px',
      dollarFormat.format(policy.coverage),
      dollarFormat.format(policy.premium * timeFactor),
      ''
    )
  })

  rows.push(...privateInsuranceRows)

  rows.push(
    createData(
      'Total',
      '',
      '',
      dollarFormat.format(allLifeInsuranceTotal?.coverage),
      dollarFormat.format(allLifeInsuranceTotal?.premium * timeFactor),
      ''
    )
  )

  return (
    <TableContainer component={Paper} sx={{ borderRadius: 1, boxShadow: 0 }}>
      <Table aria-label="Task Recommendations" size="small">
        <TableHead
          sx={{
            display: 'table-header-group',
            'th:first-of-type': {
              color: '#fff',
              borderLeft: 'none',
              borderTop: 'none',
              padding: '4px 16px',
            },
            th: {
              textAlign: 'center',
              padding: '0px',
            },
            div: {
              borderLeft: '1px solid #ddd',
              borderTop: '1px solid #ddd',
              borderRadius: '4px 4px 0 0',
              padding: '12px 16px',
              fontWeight: 600,
            },
          }}
        >
          <TableRow>
            <TableCell>Plan Name</TableCell>
            <TableCell>
              <div>Provider</div>
            </TableCell>
            <TableCell>
              <div>Coverage</div>
            </TableCell>
            <TableCell>
              <div>Premium</div>
            </TableCell>
            {tableStates.age && <TableCell>Age Coverage</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{
                '&:first-of-type td': { borderTop: '4px solid #ddd' },
                '&:last-child td, &:last-child th': { borderBottom: 0 },
                th: {
                  fontWeight: 600,
                },
                td: {
                  fontWeight: '500',
                  borderLeft: '1px solid #ddd',
                  textAlign: 'center',
                },
                // 'td:nth-child(5)': {
                //   width: '1%',
                // },
                '&:last-of-type td': {
                  borderTop: '4px solid #ddd',
                },
              }}
            >
              <TableCell scope="row" component="th">
                {row.name}
              </TableCell>
              <TableCell sx={{ img: { maxHeight: `${row.logoHeight}` } }}>
                <StyledProviderLogo src={row.providerLogo} />
              </TableCell>
              <TableCell>{row.coverage}</TableCell>
              <TableCell>{row.monthlyPremium}</TableCell>
              {tableStates.age && <TableCell>{row.ageCoverage}</TableCell>}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
